import { Box, CircularProgress, createStyles, makeStyles, Theme, Typography } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { FareastButton } from "./OverlayComponentButton";
import AddAPhotoOutlinedIcon from "@mui/icons-material/AddAPhotoOutlined";
import { Player } from "@lottiefiles/react-lottie-player";
import { useAppDispatch, useAppSelector } from "../reduxhooks";
import { fetchServiceTicket, updateServiceTicket } from "../redux/ServiceTicketRedux";
import { APIRequestStatus } from "common-ts/dist/models/APIRequestStatus";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        titleLogoDesktop: {
            marginTop: "1.5vw",
            marginBottom: "1.5vw",
            height: "4vw",
            marginLeft: "7%",
            [theme.breakpoints.only("xs")]: {
                marginTop: "7vw",
                marginBottom: "3vw",
                height: "7vw",
            },
            cursor: "pointer",
        },
        contentBox: {
            width: "60%",
            margin: "auto",
            letterSpacing: "0.1px",
            [theme.breakpoints.only("xs")]: {
                width: "85%",
            },
        },
        uploadBox: {
            width: "90%",
            margin: "auto",
        },
        title: {
            fontWeight: 600,
            fontSize: "1.2rem",
        },
        serviceListBox: {
            marginTop: "8vh",
        },
        productsContainer: {
            display: "flex",
            flexDirection: "column",
            marginTop: "15px",
        },
        productItem: {
            borderRadius: "15px",
            padding: "15px",
            marginBottom: "15px",
            display: "flex",
            flexDirection: "column",
            border: "1px solid #8a8a8aff",
        },
        productDetail: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "stretch",
        },
        productName: {
            fontSize: "0.9rem",
            fontWeight: 500,
            marginBottom: "5px",
        },
        sizeName: {
            fontSize: "0.6rem",
            color: "#8a8a8aff",
        },
        textBox: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginLeft: "10px",
            flex: 1,
            minHeight: 0,
        },
        kategoriText: {
            fontSize: "0.85rem",
            color: "#8a8a8aff",
            marginTop: "15px",
        },
        keteranganText: {
            fontSize: "0.83rem",
            color: "#8a8a8aff",
            marginTop: "8px",
            marginBottom: "10px",
        },
    })
);

export default function PageServiceStatus() {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useAppDispatch();
    const serviceTicketState = useAppSelector((state) => state.serviceTicketState.serviceTicketObject);
    const requestStatus = useAppSelector((state) => state.serviceTicketState.status);
    const [descriptionList, setDescriptionList] = useState<any[]>([]);
    let { idLapor } = useParams<{ idLapor: string }>();

    const fileInputRef = useRef<HTMLInputElement>(null);

    function navigateHome() {
        history.push("/shop");
    }

    useEffect(() => {
        dispatch(fetchServiceTicket(idLapor));
    }, [idLapor]);

    useEffect(() => {
        if (serviceTicketState && serviceTicketState.descriptionList) {
            try {
                setDescriptionList(JSON.parse(serviceTicketState.descriptionList));
            } catch (e) {
                console.error("Gagal parse JSON", e);
            }
        }
    }, [serviceTicketState]);

    const handleUploadClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;

        // pastikan itu gambar
        if (!file.type.startsWith("image/")) {
            alert("File harus berupa gambar!");
            return;
        }

        dispatch(updateServiceTicket({ file: file, timestamp: idLapor }));
    };

    if (serviceTicketState === undefined) {
        return (
            <Box>
                <Link onClick={navigateHome} to={""}>
                    <img className={classes.titleLogoDesktop} src={"https://studiosclo.uk/legacy/sur_monogram_minimum.svg"} alt="maja logo" />
                </Link>
            </Box>
        );
    }

    return (
        <>
            <Box>
                <Link onClick={navigateHome} to={""}>
                    <img className={classes.titleLogoDesktop} src={"https://studiosclo.uk/legacy/sur_monogram_minimum.svg"} alt="maja logo" />
                </Link>
            </Box>
            {serviceTicketState.status === "DIMULAI" ? (
                <>
                    <Box className={classes.contentBox}>
                        <Box className={classes.uploadBox}>
                            <Typography className={classes.title}>Upload Bukti Pengiriman</Typography>

                            <input type="file" ref={fileInputRef} style={{ display: "none" }} accept="image/*" onChange={handleFileChange} />

                            <FareastButton
                                buttonMarginLeftRight="auto"
                                buttonMarginTopBottom="25px"
                                style={{ display: "flex", alignItems: "center", width: "100%" }}
                                onClick={handleUploadClick}
                                disabled={requestStatus === APIRequestStatus.RequestInProgress}
                            >
                                <Box display="flex" alignItems="center">
                                    {requestStatus === APIRequestStatus.RequestInProgress ? (
                                        <CircularProgress />
                                    ) : (
                                        <>
                                            <AddAPhotoOutlinedIcon style={{ transform: "scaleX(-1)", fontSize: "20px", marginBottom: "5px" }} />
                                            <span style={{ marginLeft: "10px", fontSize: ".9rem" }}>UPLOAD BUKTI PENGIRIMAN</span>
                                        </>
                                    )}
                                </Box>
                            </FareastButton>
                        </Box>

                        <Box className={classes.serviceListBox}>
                            <Typography className={classes.title}>Permintaan Sevis Produk</Typography>
                            {/* TODO: loop daftar service ticket setelah fetch */}
                            {descriptionList &&
                                descriptionList.length > 0 &&
                                descriptionList.map((desc, index) => (
                                    <Box key={index} className={classes.productsContainer}>
                                        <Box className={classes.productItem}>
                                            <Box className={classes.productDetail}>
                                                <img src={desc.productImage} alt={desc.productName} style={{ width: "35px", marginTop: "auto", marginBottom: "auto" }} />
                                                <Box className={classes.textBox}>
                                                    <Typography className={classes.productName}>{desc.productName}</Typography>
                                                    <Typography className={classes.sizeName}>{desc.productSize}</Typography>
                                                </Box>
                                            </Box>
                                            <Typography className={classes.kategoriText}>{desc.category === "TUKAR_SIZE" ? "TUKAR SIZE" : `${desc.category}`}</Typography>
                                            <Typography className={classes.keteranganText}>{desc.description}</Typography>
                                        </Box>
                                    </Box>
                                ))}
                        </Box>
                    </Box>
                </>
            ) : (
                <Box className={classes.contentBox}>
                    <Player
                        key="done-animation"
                        autoplay
                        loop
                        src="https://studiosclo.uk/general/Lottie_Jahit.json"
                        style={{
                            height: "150px",
                            marginTop: "14px",
                            marginBottom: "14px",
                        }}
                    ></Player>
                    <Box style={{ marginTop: "30px" }}>
                        <Typography className={classes.title}>Proses Pengerjaan</Typography>
                        <Typography className={classes.keteranganText}>Laporan kamu akan diproses maksimal 2 minggu setelah barang diterima.</Typography>
                    </Box>
                    {/* TODO-BRYAN: kasih estimasi */}
                    <Box style={{ marginTop: "30px", marginBottom: "40px" }}>
                        <Typography className={classes.title}>Estimasi Pengerjaan Servis</Typography>
                        <Typography className={classes.keteranganText}>Tukar Size : 3 - 4 Hari Kerja (Bahan Tersedia)</Typography>
                        <Typography className={classes.keteranganText}>Permak Produk Kecil : 5 - 6 Hari Kerja</Typography>
                        <Typography className={classes.keteranganText}>Permak Produk Besar : 7 - 9 Hari Kerja</Typography>
                    </Box>
                    <Typography className={classes.keteranganText}>Kami akan menghubungi lebih lanjut melalui whatsapp untuk informasi seputar pengerjaan produk kamu.</Typography>
                </Box>
            )}
        </>
    );
}
